import React, { useRef } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { EmployeeConfigMasterForm, EmployeeConfigMasterFormRefHandle } from './EmployeeConfigMasterForm';
import { EmployeeConfigMaster } from 'models/config/EmployeeConfigMaster';

export type EmployeeConfigMasterFormModalProps = {
    title: string;
    isOpen: boolean;
    onClose: () => void;
    disabledKeyField?: boolean;
    defaultValues?: EmployeeConfigMaster;
    onSubmit?: (employeeConfigMaster: EmployeeConfigMaster) => void;
};

export const EmployeeConfigMasterFormModal = (
    props: EmployeeConfigMasterFormModalProps
) => {
    const {
        disabledKeyField,
        title,
        isOpen,
        onClose,
        defaultValues,
        onSubmit
    } = props;

    const formRef = useRef<EmployeeConfigMasterFormRefHandle>(null);

    const handleSaveClick = () => {
        const employeeConfigMaster = formRef.current?.submit();
        if (!employeeConfigMaster) {
            return;
        }

        onSubmit?.(employeeConfigMaster);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                <EmployeeConfigMasterForm
                    ref={formRef}
                    disabledKeyField={disabledKeyField}
                    defaultValues={defaultValues}
                />
            </ModalBody>
            <ModalFooter className="tw-flex tw-justify-end">
                <Button
                    color="primary"
                    onClick={handleSaveClick}
                >
                    Save
                </Button>
                <Button
                    color="secondary"
                    onClick={onClose}
                    className="tw-border-none tw-bg-neutral-600"
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};
